module.exports = __webpack_public_path__ + "img/upload.8bd12979.png";